<div mat-dialog-content>
    <p>
        {{ 'aumico_reports_accept_policy_to_continue_dialog_first_paragraph' | i18next }}
    </p>
    <p>
        {{ 'aumico_reports_accept_policy_to_continue_dialog_second_paragraph' | i18next }}
    </p>
    <span>
        {{ 'aumico_reports_accept_policy_to_continue_dialog_third_paragraph' | i18next }}
    </span>
    <span class="contact-email">
        {{ 'aumico_reports_accept_policy_to_continue_dialog_third_paragraph_contact_email' | i18next }}
    </span>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button color="basic" (click)="declinePolicy()">
            {{ 'aumico_reports_accept_policy_to_continue_dialog_decline_policy_button' | i18next }}
        </button>
        <button aum-button color="blue" (click)="acceptPolicy()">
            {{ 'aumico_reports_accept_policy_to_continue_dialog_i_agree_button' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
